import Card from "../../../../components/UI/Card";
import {useParams, useRoutes} from "react-router-dom";
import Checkbox from "../../../../components/UI/form/Checkbox";
import React, {useState} from "react";
import Button from "../../../../components/UI/Button";
import {useMutation} from "@tanstack/react-query";
import {creteOrderSubmit, refundRequest, updateOrder} from "../../../../api/orders";
import {toast} from "react-toastify";
import {setOrderForm} from "../../../../store/slices/orderSlice";
import {setValidationMessage} from "../../../../util/validationMessage";
import {confirmAlert} from "react-confirm-alert";
import {useNavigate} from "react-router";

const PaymentInformation = ({order, setValue, control, errors, getValues, register, watch}) => {
  const params = useParams()
  const getMessageClass = (status) => {
    let className = '';
    if(status === 'Pending')
      className = 'color_warning';

    if(status === 'success')
      className = 'color_success_type_2';

    if(status === 'Fail')
      className = 'text_red';

    return className;
  }

  const [toastId, setToastId] = useState(null);
  const {mutate, isPending, } = useMutation({
    mutationFn: (data) => refundRequest(order.id),
    onMutate: () => {
      setToastId(toast.loading("Please wait..."))
    },
    onSuccess: (res) => {
      window.location.reload();
      toast.update(toastId, { render: `Order Submited`, type: "success", isLoading: false, autoClose: true });
    },
    onError: (error) => {
      let errorMsg = "Something happened!";
      toast.update(toastId, { render: errorMsg, type: "error", isLoading: false, autoClose: true });
    }
  });

  const handleRefundRequest = () => {
    confirmAlert({
      title: 'Refund',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            mutate()
          },
        },
        {
          label: 'No',
          onClick: () => {
            return;
          }
        }
      ]
    });

  }
  const getStatusClass = () => {
     let className = '';

     if(order.group.payment_status === 'success')
       className = 'color_success'

     if(order.group.payment_status === 'Fail')
       className = 'color_danger'

     if(order.payment_status === 'Refunded')
       className = 'color_warning'

     return className;
  }
  const getStatusText = () => {
     let text = '';

     if(order.group.payment_status === 'success')
       text = 'Success'

     if(order.group.payment_status === 'Fail')
       text = 'Fail'

     if(order.payment_status === 'Refunded')
       text = order.payment_message

     return text;
  }
  const checkRefundAvailability = ()=>{
    let status = false
    if(order.payment_status != 'Refunded' && order.group.payment_status != 'Fail'){
      status = true
    }
    if(order.payment_message === 'Refunded Failed'){
      status = true
    }
    if(order.group?.charge_id === null){
      status = false
    }
    if(order.status === 5){
      status = false
    }

    return status
  }

  return (
    <>
      {params.id != undefined ?
        <Card>
          <h1 className="common_sub_title mt_0 mb_5">
            <span>Payment Information</span>
          </h1>
          {order && order.group &&
              <>
                <div className="checkout_summery">
                  <table className="table border_none mb_0">
                    <tbody>
                    <tr>
                      <td className="text_left width_100p fw_600">Payment Status</td>
                      <td className={`${getStatusClass()}`}>{getStatusText()}</td>
                    </tr>
                    <tr>
                      <td className="text_left width_100p fw_600">Payment Method</td>
                      <td>{order.group.payment_method === 'stripe' ? "Card" : "Cash On Delivery"}</td>
                    </tr>
                    {order.group.card_brand && order.group.payment_method === 'stripe' ?
                      <>
                        <tr>
                          <td className="text_left width_100p fw_600"><img style={{'width': '34px'}}
                                                                           src="/assets/media/images/visa.png"
                                                                           alt=""/></td>
                          <td>**** **** {order.group.card_number}</td>
                        </tr>
                        <tr>
                          <td colSpan={2}>
                            {checkRefundAvailability() &&
                            <Button text={"Refund"} onClickHandler={handleRefundRequest}/>
                            }
                          </td>
                        </tr>
                      </> : ''
                    }
                    </tbody>
                  </table>
                </div>
              </>
          }
        </Card>
        :
        <Card>
          <h1 className="common_sub_title mt_0 mb_5">
            <span>Payment Information</span>
            </h1>
            <Checkbox name={`payment_method`}
                      label={"Cash On Delivery"}
                      classes="mb_0 pt_10"
                      register={register}
                      validationRules={{required:true}}
                      checked={getValues(`payment_method`) === 'cod' ? 1 : 0} />
          </Card>
      }
    </>
  );
}

export default PaymentInformation